export default "__VITE_ASSET__Cow48Z5o__"